export const ROOT_FOLDER_ID = "0";
export const ROOT_FOLDER_NAME = "Root";
export const CRYPTO_FOLDER = "Crypto Folder";

export const MODE_SELECT = "select";
export const MODE_UPLOAD = "upload";
